import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URLS } from 'src/app/config/api-urls';
import { QueryResponse } from 'src/app/shared/models/query-response';
import { Observable } from 'rxjs';
import { NewAccount } from './models/new-account.model';
import { PreviousUploadEvents } from './models/previous-bulk-uploads.model';
import { NewBulkAccounts } from './models/bulk-upload.model';
import { BulkAccountUploadStatus, PreviousImportsDetail } from '../store/new-accounts.state';

@Injectable({
  providedIn: 'root'
})
export class NewAccountApiService {
  private http = inject(HttpClient);

  private createNewAccountUrl = API_URLS.CREATE_NEW_ACCOUNT;
  private bulkAccountImportUrl = API_URLS.BULK_ACCOUNT_IMPORT;
  private previousBulkImportsUrl = API_URLS.PREVIOUS_BULK_IMPORTS;

  createNewAccount(accountDetails: NewAccount): Observable<QueryResponse<{ accountId: string }>> {
    return this.http.post<QueryResponse<{ accountId: string }>>(this.createNewAccountUrl, {
      accountType: accountDetails.accountType,
      email: accountDetails.email,
      firstName: accountDetails.firstName,
      lastName: accountDetails.lastName,
      countryId: Number(accountDetails.countryId),
      language: Number(accountDetails.language),
      institutionName: accountDetails.institutionName,
      telephoneNumber: String(accountDetails.telephoneNumber),
      county: accountDetails.county,
      postcode: accountDetails.postcode,
      jobTitle: accountDetails.jobTitle
    });
  }

  uploadBulkAccounts(bulkAccountData: NewBulkAccounts): Observable<QueryResponse<{ eventId: string }>> {
    return this.http.post<QueryResponse<{ eventId: string }>>(this.bulkAccountImportUrl, {
      csvData: bulkAccountData.csvData,
      accountType: bulkAccountData.accountType,
      countryId: Number(bulkAccountData.countryId),
      language: Number(bulkAccountData.language),
      accountNoteText: bulkAccountData.accountNoteText ?? '',
      subscriptionPreset: Number(bulkAccountData.subscriptionPreset),
      sendEmails: bulkAccountData.sendEmails
    });
  }

  getBulkAccountsStatus(eventId: string): Observable<BulkAccountUploadStatus> {
    return this.http.get<BulkAccountUploadStatus>(`${this.previousBulkImportsUrl}/${eventId}/status`);
  }

  getPreviousBulkImports(pageNumber: number, pageSize: number): Observable<PreviousUploadEvents> {
    const params = new HttpParams().set('pageSize', pageSize.toString()).set('pageNumber', pageNumber.toString());

    return this.http.get<PreviousUploadEvents>(this.previousBulkImportsUrl, {
      params
    });
  }

  getSelectedBulkImportDetail(eventId: string, pageSize: number): Observable<PreviousImportsDetail> {
    const params = new HttpParams().set('pageSize', pageSize.toString()).set('filter', '2');

    return this.http.get<PreviousImportsDetail>(`${this.previousBulkImportsUrl}/${eventId}`, {
      params
    });
  }

  getPreviousBulkImportFile(eventId: string): Observable<Blob> {
    return this.http.get(`${this.previousBulkImportsUrl}/${eventId}/download`, {
      responseType: 'blob'
    });
  }
}
